export default __webpack_public_path__ + "static/media/trash-icon.2ad6e31b.svg";